import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { RootState } from "@store/.";

import { DominantColor } from "@components/Common";

import ReportingIcon from "../../assets/images/ReportingIcon.svg";
import ReportingConnecsIcon from "../../assets/images/ReportingConnecsIcon.svg";

import SidebarCollapsedSvgIcon from "./SidebarCollapsedSvgIcon";
import { StyledSidebarMenu } from "./StyledSidebarMenu";

import "../index.css";

type SidebarProps = {
    brand: string;
};

export default function Sidebar({ brand }: SidebarProps) {
    const { t } = useTranslation();
    const isAuthorized = localStorage.getItem("authorized");
    const dominantColor = DominantColor();
    const collapsed = useSelector(
        (state: RootState) => state.layoutSlice.collapsed
    );
    const selectedAccountId = localStorage.getItem("customerAccountId");
    const menuItems = !isAuthorized
        ? [
              {
                  icon: (
                      <img
                          src={ReportingIcon}
                          id="ReportingIconButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          height={30}
                          width={30}
                          alt=""
                      />
                  ),
                  link: "",
                  menuItem: t("Reporting"),
                  menuItemClass: "sid_txt_accountManagement",
                  uid: "1",
                  subMenu: [
                      {
                          link: "/Reporting/transactions",
                          menuItem: t("Transactions"),
                          subMenuClass: "sid_txt_transactions",
                          uid: "2",
                      },
                      //   {
                      //       link: "/Reporting/paiements",
                      //       menuItem: t("Payout"),
                      //       subMenuClass: "sid_txt_paiements",
                      //       uid: "3",
                      //   },
                      //   {
                      //       link: "/Reporting/rapports",
                      //       menuItem: t("Reporting des transactions"),
                      //       subMenuClass: "sid_txt_rapports",
                      //       uid: "4",
                      //   },
                      {
                          link: "/Reporting/AdvancedReports",
                          menuItem: t("Daily POS Report"),
                          subMenuClass: "sid_txt_rapports_avance",
                          uid: "5",
                      },
                      {
                          link: "/Reporting/Payments",
                          menuItem: t("Payments"),
                          subMenuClass: "sid_txt_Payments",
                          uid: "6", 
                      },
                      //    {
                      //       link: "/Reporting/AdvancedEcomReports",
                      //       menuItem: t("Reporting journalier Ecommerce"),
                      //       subMenuClass: "sid_txt_rapports_avance",
                      //       uid: "6",
                      //   },
                  ],
              },
              {
                  icon: (
                      <img
                          src={ReportingConnecsIcon}
                          id="ReportingConnecsButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          height={30}
                          width={30}
                          alt=""
                      />
                  ),
                  link: "/#",
                  menuItem: t("Reporting Connecs"),
                  menuItemClass: "sid_txt_reportingConnecs",
                  uid: "5090fe0f",
                  subMenu: [
                      {
                          link: "/ReportingConecs/paiements",
                          menuItem: t("Transactions conecs"),
                          subMenuClass: "sid_txt_paiements",
                          uid: "5090",
                      },
                  ],
              },
          ]
        : [];

    return (
        <StyledSidebarMenu
            brand={
                <span
                    className="sid_btn_nameOfTheProject"
                    style={{
                        cursor: selectedAccountId !== "" ? "pointer" : "auto",
                    }}
                    role="button"
                    tabIndex={0}
                >
                    {collapsed ? <SidebarCollapsedSvgIcon /> : brand}
                </span>
            }
            collapsed={collapsed}
            backgroundColor={dominantColor}
            menuItems={menuItems}
        />
    );
}
